<template>
    <div v-if="lang" class="cookie-status">
        <div class="row" v-show="modal_show">
            <div  class="cookies-status">
                <div class="col">{{ lang.text }} 
                    <div class="mx-auto text-center pt-1">
                        <button type="button" class="btn bluecta">
                            <a rel="noopener" :href="lang.policy_url" target="_blank" class="linkCookie">
                                {{ lang.policy }}
                            </a>
                        </button>

                        <button @click="cookieAccept" type="button" class="btn bluecta">
                            {{ lang.accept }}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import VueCookies from 'vue-cookies'

export default {
    data() {
        return {
            modal_show: ($cookies.get('cookie_status')) ? false : true
        }
    },

    computed: {
        lang() {
            return this.$root.lang.cookie
        }
    },

    methods: {
        cookieAccept() {
            $cookies.set('cookie_status', true, '1y', '', '', true)
            this.modal_show = false
        }
    }
}
</script>
